import axios from 'axios';

export const KATOService = {
  async getKATO(page, perPage) {
    const res = await axios.get('regions/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },
  async getAllKATO() {
    const res = await axios.get('regions/all/');

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },
  async createKATO(data) {
    const res = await axios.post('regions/', data);

    if (res.status === 201) {
      return true;
    }
    return Promise.reject();
  },
  async deleteKATO(id) {
    const res = await axios.delete(`regions/${id}`);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
  async updateKATO(data, id) {
    const res = await axios.put(`regions/${id}/`, data);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
  async getParentRegions() {
    const res = await axios.get('regions/parents/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
